import { taskIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const completeCycleCount = {
  name: "completeCycleCount" as const,
  input: z.object({ taskId: taskIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
